import { setCookie, removeCookie } from '@/utils/cookie'

export default {
  setLoginStatus(state, payload) {
    // 设置登录状态
    state.loginStatus = payload
    sessionStorage.setItem('ydshPhH5Bankv3LoginStatus', payload)
  },

  signOut(state) {
    sessionStorage.removeItem('ydshPhH5Bankv3LoginStatus')
    sessionStorage.removeItem('xiameBankAscendGoldToken')
    sessionStorage.removeItem('jiangsuDigitalCoinLotteryToken')
    sessionStorage.removeItem('newAccountDigitalLotteryToken')
    sessionStorage.removeItem('psbcNationalDayLotteryToken')
    sessionStorage.removeItem('cibNationalDayToken')
    sessionStorage.removeItem('ptActBizToken')
    sessionStorage.removeItem('huijuToken')
    sessionStorage.removeItem('signInGiftToken')
    sessionStorage.removeItem('yunnanPsbcToken')
    sessionStorage.removeItem('xiameBankXibSaveMoneyToken')
    sessionStorage.removeItem('xibWorkWeChatLotteryToken')
    sessionStorage.removeItem('xiameBankPromotionJhToken')
    sessionStorage.removeItem('xibBirthdayGiftToken')
    sessionStorage.removeItem('xibBirthdayGiftWxAuthPending')
    removeCookie('womensDayToken')
  },

  // 设置登录成功后会跳的路由
  setLandPage(state, payload) {
    state.landPageRoute = payload
    sessionStorage.setItem('ydshPhH5Bankv3PageRoute', payload)
  },


  // 设置token
  setBankToken(state, payload) {
    state.bankToken = payload
    setCookie('acquisitionBankToken', payload)
  },
  setHeavyCustomerToken(state, payload) {
    state.heavyCustomerToken = payload
    setCookie('acquisitionHeavyCustomerToken', payload)
  },
  setBusinessToken(state, payload) {
    state.businessToken = payload
    setCookie('acquisitionBusinessToken', payload)
  },
  setReferenceToken(state, payload) {
    state.referenceToken = payload
    setCookie('acquisitionReferenceToken', payload)
  },
  setUserToken(state, payload) {
    state.userToken = payload
    sessionStorage.setItem('acquisitionUserToken', payload)
  },

  // 退出登录
  bankSignOut(state) {
    state.bankToken = ''
    removeCookie('acquisitionBankToken')
  },
  heavyCustomerSignOut(state) {
    state.heavyCustomerToken = ''
    removeCookie('acquisitionHeavyCustomerToken')
  },
  businessSignOut(state) {
    state.businessToken = ''
    removeCookie('acquisitionBusinessToken')
  },
  referenceSignOut(state) {
    state.referenceToken = ''
    removeCookie('acquisitionReferenceToken')
  },
  userSignOut(state) {
    state.userToken = ''
    sessionStorage.removeItem('acquisitionUserToken')
  },


  setStateByName(state, payload) {
    let keys = Object.keys(payload)
    keys.map(key => {
      state[key] = payload[key]
    })
  },


}

